import { TaxonomyHeader } from './TaxonomyList/TaxonomyHeader';
import { TaxonomyList } from './TaxonomyList/TaxonomyList';

export const TaxonomyListPage = () => {
  return (
    <TaxonomyHeader>
      <TaxonomyList />
    </TaxonomyHeader>
  );
};
